export const TRANSLATIONS = {
  en: true,
  sv: true,
  fr: true,
  it: true,
  es: true,
  tr: true,
  hu: true,
  el: true,
  nl: true,
  de: true,
}



// WEBPACK FOOTER //
// ./src/constants.js